module.exports = __webpack_public_path__ + "static/img/15023B_1_R_20211024_LC.7e79518.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/15023B_1_R_20211024_LC.png
// module id = bHNl
// module chunks = 0